import { TextArea, TextAreaProps } from '@volkswagen-onehub/components-core';
import React from 'react';
import { FORM_MESSAGE } from '../../../../constants/form-constants';
import { STYLED_INPUT } from '../../../../constants/styles-constants';
import { formService } from '../../../../form-service';
import { useFormField } from '../../../../hooks/use-form-field';

interface Props extends Omit<TextAreaProps, 'onChange' | 'onFocus' | 'onBlur'> {
	name: string;
	label: string;
	value?: string;
	rows?: number;
	required?: boolean;
	disabled?: boolean;
	maxLength?: number;
	infoMessage?: string;
	validate?: (value: string) => boolean;
	errorMessage?: string;
	inputRef?: React.RefObject<HTMLInputElement>;
	onChange?: (e: any) => void;
	onFocus?: (e: any) => void;
	onBlur?: (e: any) => void;
}

export function TextAreaExtended(props: Props) {
	const {
		name,
		value,
		rows,
		required,
		disabled,
		maxLength,
		errorMessage,
		infoMessage,
		validate,
		onBlur,
		onChange,
		onFocus,
	} = props;

	const { currentValue, validationError } = useFormField({
		name,
		value,
		required,
		validate,
	});
	const internalRef = React.useRef<HTMLInputElement>(null);
	const inputRef = props.inputRef || internalRef;

	const handleChange = (e: any) => {
		formService.setFieldValue(name, e.target.value);
	};

	const message = validationError ? errorMessage || FORM_MESSAGE.REQUIRED_FIELD : infoMessage || undefined;

	const appearance = validationError ? 'error' : disabled ? 'disabled' : infoMessage ? 'information' : 'default';

	return (
		<div
			className="textarea"
			ref={inputRef}
			style={{
				marginLeft: STYLED_INPUT.margin.left,
				marginRight: STYLED_INPUT.margin.right,
				marginTop: STYLED_INPUT.margin.top,
				marginBottom: STYLED_INPUT.margin.bottom,
			}}
		>
			<TextArea
				{...props}
				value={currentValue}
				rows={rows ? rows : 3}
				maxLength={maxLength}
				required={required}
				message={message}
				appearance={appearance}
				onChange={(e: any) => {
					if (onChange) onChange(e);
					handleChange(e);
				}}
				onBlur={(e: any) => {
					if (onBlur) onBlur(e);
				}}
				onFocus={(e: any) => {
					if (onFocus) onFocus(e);
				}}
			/>
		</div>
	);
}
